module.exports = __webpack_public_path__ + "img/paynow-logo.ca0d7675.png";